<template>
  <div class="main scroll">
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <img style="width: 14px;height: 14px;margin-right: 4px;" src="../../assets/director/icon (5).png" alt="">
          <div @click="$router.back()" class="name">成长册</div>
        </div>
        <div class="right">
          <div class="time">
            全园信息
          </div>
        </div>
      </div>

      <div class="table_head">
        <div class="name">
          全园成长册
        </div>
      </div>
      <div class="search">
        <a-input-search style="width: 300px;" v-model="form.student_name" placeholder="学生姓名检索" enter-button @search="onSearch" />
      </div>
      <div class="table" style="background: #fff;">
          <a-table :loading="spinning"  rowKey='id' :pagination="false" :dataSource="table" :columns="column">
            <template slot="head_img"  slot-scope="text, record">
              <a-avatar v-if="text" shape="square" :size="44" :src="text" />
              <div v-else>-</div>
            </template>
            <template slot="progress"  slot-scope="text, record">
              {{ text ? text : '-' }}
            </template>
           <template slot="actions"  slot-scope="text, record">
              <a-button size="small" style="background-color: #67b0dc;border: none;" @click="look(record)" type="primary" shape="round" icon="edit">查看成长册</a-button>
            </template>
        </a-table>

        <div style="text-align: center;padding: 15px 0;">
          <a-pagination v-model="form.page" @change="getPross" :total="total" :pageSize="form.pageSize" show-less-items />
        </div>
        
      </div>
    </div>
    <a-modal
      :title="'成长册列表-' + name"
      :visible="visible"
      :footer="false"
      width="86%"
      @cancel="visible = false"
    >
      <a-spin style="min-height: 200px;" :spinning="spinning"><div style="padding: 0 25px;"><a-alert message="点击黑色阴影处也可关闭弹窗" type="info" /></div> <pc-growup v-if="visible"  :guc_id="guc_id" :sid="sid"></pc-growup></a-spin>
    </a-modal>

  </div>
</template>

<script>
import { directorApi } from '../../api/api-director';
import { mapState } from 'vuex';
import pcGrowup from '../pcGrowup.vue';

export default {
  data() {
    return {
      column:[
          {
            title: '学生姓名',
            dataIndex: 'name',
            key: 'name',
            scopedSlots: { customRender: "name" },
          },
          {
            title: '头像',
            dataIndex: 'head_img',
            key: 'head_img',
            scopedSlots: { customRender: "head_img" },
          },
          {
            title: '完成进度',
            dataIndex: 'progress',
            key: 'progress',
            scopedSlots: { customRender: "progress" },
          },{
            title: '操作',
            dataIndex: 'actions',
            key: 'actions',
            scopedSlots: { customRender: "actions" },
          }],
      table:[],
      spinning:false,
      visible:false,
      guc_id:'',
      sid:'',
      submitModal:false,
      is_complete:false,
      name:'',
      class_name: '',
      form:{
        page:1,
        pageSize: 10,
        student_name: '',
        class_id: ''
      },
      total: 0
    };
  },
  components:{
    pcGrowup
  },
  computed: {
    ...mapState(['headers','school'])
  },
  created() {
    this.form.class_id = this.$route.params.id
    if (this.school) {
      this.getPross()
    }
  },
  watch: {
    school(val) {
      if (val) {
        this.getPross() 
      }
    }
  },
  methods: {
    onSearch() {
      this.form.page = 1
      this.getPross()
    },
    getDetail() {
      this.$axios({
          method: "GET",
          url: this.$api.domain + this.$api.growupDetail,
          headers: { Authorization: this.headers },
          params: {
            guc_id: this.table[0].guc_id,
            s_id: this.table[0].id,
          },
        })
          .then((res) => {
            if (res.data.status == 200 && res.data.data) {
              this.is_complete = res.data.data.info.is_complete ? true : false;
            }
          })
          .catch((res) => {
            // this.$message.error(res.data.msg);
          });
    },
    look(record) {
      this.spinning = true
      this.guc_id = record.guc_id
      this.sid = record.id
      this.visible = true
      this.name = record.name
      setTimeout(() => {
        this.spinning = false
      }, 1500);
    },
    getPross() {
      this.spinning = true
      this.$axios({
        method: "GET",
        url: directorApi.domain + directorApi.studentProgressList,
        headers: { Authorization: this.$store.state.headers },
        params: this.form
      })
        .then((res) => {
          if (res.data.status == 200) {
            console.log(res)
            this.table = res.data.data.list
            this.total = res.data.data.total_page * this.form.pageSize 
            setTimeout(() => {
              this.spinning = false
            }, 100);
          }
        })
        .catch((res) => {
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .right .time {
    font-size: 14px;
    color: #666;
  }


  .fixed{
    position: fixed;
    right: 30px;
    bottom: 30px;
    padding: 10px 20px;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    background: #d18c53;
    cursor: pointer;
  }

  .table_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    background: #78afd6;
    margin-top: 20px;
    padding: 10px 0;
    .name {
      font-weight: 600;
      color: #fff;
      margin-left: 20px;
      font-size: 16px;
    }
    border-radius: 12px 12px 0 0;
  }

  .search {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    justify-content: flex-end;
    background: #fff;
  }
</style>
